export default __webpack_public_path__ + "0bdac3345ecd944230563a68ad4ec053.pdf";